import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M30 36.667q-2.084 0-3.542-1.459Q25 33.75 25 31.667q0-.293.042-.605.041-.314.125-.562l-11.75-6.833q-.709.624-1.584.98A4.8 4.8 0 0 1 10 25q-2.084 0-3.542-1.458Q5 22.083 5 20q0-2.084 1.458-3.542Q7.917 15 10 15q.959 0 1.833.355a5.5 5.5 0 0 1 1.584.978L25.167 9.5a3 3 0 0 1-.125-.562A5 5 0 0 1 25 8.333q0-2.084 1.458-3.541Q27.917 3.332 30 3.333q2.084 0 3.542 1.459Q35 6.25 35 8.333q0 2.085-1.458 3.542-1.459 1.458-3.542 1.458-.959 0-1.833-.353a5.5 5.5 0 0 1-1.584-.98l-11.75 6.833q.084.25.125.564Q15 19.71 15 20q0 .291-.042.605a3 3 0 0 1-.125.562L26.583 28q.709-.626 1.584-.978A4.9 4.9 0 0 1 30 26.667q2.084 0 3.542 1.458T35 31.667t-1.458 3.541q-1.459 1.46-3.542 1.459"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }